@if (overflowingCurrentSelections?.length > 0) {
<div class="filter-chip-overflow-button" data-cy="chip-overflow-button">
  <button
    mat-button
    class="text-uppercase"
    color="accent"
    data-cy="filter-chip-overflow-button"
    [matMenuTriggerFor]="fullChipList"
  >
    <mat-icon>more_horiz</mat-icon>
  </button>
</div>
}

<mat-menu #fullChipList="matMenu" xPosition="before">
  <div class="current-selections-menu-header">
    <h4>Current Selections</h4>
  </div>
  <div class="current-selections-menu-body">
    <mat-chip-listbox
      class="mat-mdc-chip-set-stacked"
      aria-label="Current Filter Selections"
    >
      @for (currentSelection of overflowingCurrentSelections; track
      currentSelection) {
      <mat-chip
        class="mat-standard-chip"
        (removed)="
          filterService.removeFilterSelectionByDisplay(currentSelection)
        "
      >
        {{ currentSelection.filterKeyLabel }}:
        {{ currentSelection.filterValueLabel }}
        <button matChipRemove>
          <mat-icon
            [attr.data-cy]="
              'chip-overflow-remove-button-' +
              currentSelection.filterKey +
              '-' +
              currentSelection.filterValue
            "
            >cancel</mat-icon
          >
        </button>
      </mat-chip>
      }
    </mat-chip-listbox>
  </div>
  <div class="current-selections-menu-footer">
    <button
      mat-stroked-button
      color="accent"
      data-cy="filter-overflow-clear-filters-button"
      (click)="filterService.clearFilterBarFilters()"
    >
      CLEAR ALL FILTERS
    </button>
  </div>
</mat-menu>
